import { configureStore } from '@reduxjs/toolkit';
import contactReducer from './slices/contactSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import transactionReducer from './slices/transactionSlice';
import adminSlice from './slices/adminSlice';
import documentReducer from './slices/documentSlice';
import transactionApprovalReducer from './slices/transactionApprovalSlice';

export const store = configureStore({
  reducer: {
    contact: contactReducer,
    auth: authReducer,
    user: userReducer,
    transaction: transactionReducer,
    admin: adminSlice,
    document: documentReducer,
    transactionApproval: transactionApprovalReducer,
  },
});

export default store;